import Link from 'next/link'
import { ArrowUpRight } from 'lucide-react'

export default function ExploreLink({ href, children }: { href: string; children: React.ReactNode }) {
 return <Link prefetch={false} href={href} className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-lg bg-gradient-to-r from-purple-600 to-blue-500 px-3 py-2 text-[11px] font-bold text-white transition-[filter] hover:brightness-110">
  {children}<ArrowUpRight className="size-3" aria-hidden="true" />
 </Link>
}
